import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'ApexChart',
  label: 'Apex Sample Chart',
  icon: 'DocumentTextIcon',
  description: 'Fields for a the apex chart icon',
  properties: [
    {
      label: 'Chart Type',
      name: 'chartType',
      editor: 'textbox',
      readonly: false,
      description: 'The type of chart to display',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Data Path',
      name: 'chartDataPath',
      editor: 'textbox',
      readonly: false,
      description:
        'Enter a string that represents an object page on the page data object, that will be supplied to this chart. The object should contain an Apex Chart configuration along with the data to display.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
